








import {Component, Prop, Vue} from 'vue-property-decorator';
import {Song} from '@/assets/songs';

@Component
export default class SongListItem extends Vue
{
  @Prop() song!: Song;
  @Prop() nowPlaying = false;

  handleClick()
  {
    this.$emit('click', this.song);
  }
}
